import React from 'react';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell , { tableCellClasses } from '@mui/material/TableCell';
import { Box, TableSortLabel } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

const TableHeader = (props) => {
  const {  order, orderBy, onRequestSort, columns } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

    return(
      <TableHead>
      <TableRow> 
        {columns.map((column) => (
          <TableCell
            key={column.id}
            align={column.numeric ? 'right' : 'left'}
            padding={column.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === column.id ? order : false}
            sx={{
              [`&.${tableCellClasses.head}`]: {
                backgroundColor: '#f5f5f5',
                fontWeight: 600,
              }
            }}
          >
            <TableSortLabel
              active={orderBy === column.id}
              direction={orderBy === column.id ? order : 'asc'}
              onClick={createSortHandler(column.id)}
              key={column.id}
            >
              {column.label}
              {orderBy === column.id ? (
                <Box component="span" sx={visuallyHidden} key={column.id}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
    )
}

export default TableHeader;